export default (props, custom = {}) =>
  Object.assign(custom, {
    role: props.organizationMember.role,
    project: props.project ? props.project.id : null,
    organization: props.organization ? props.organization.id : null,
    user: props.user.id
  });
